module.exports = __webpack_public_path__ + "static/img/bg-tr.c39b1298.webp";